function pushCartToken() {
  fetch('/cart.js')
    .then(function(res) { return res.json(); })
    .then(function(cart) {
      if (cart?.token) {
        // Bridge to custom pixel via analytics.publish
        if (globalThis.Shopify?.analytics?.publish) {
          globalThis.Shopify.analytics.publish('cart_token_updated', {
            cartId: cart.token
          });
        }
      }
    })
    .catch(function(err) {
      console.error('[SK-II] Failed to fetch cart token:', err);
    });
}

document.addEventListener('DOMContentLoaded', pushCartToken);
document.addEventListener('cart:updated', pushCartToken);
